import Splide from '@splidejs/splide';
import { v4 as uuidv4 } from 'uuid'

(function() {
	'use strict'

	document.addEventListener( 'DOMContentLoaded', () => {
		/* Setup */
		let slider_options = {
				type: 'slide',
				perPage: 1,
				perMove: 1,
				gap: 0,
				rewind: true,
				pagination: false,
				mediaQuery: 'min',
				breakpoints: {
					768: {
						perPage: 2,
						perMove: 2,
						gap: '2.4rem'
					},
					1024: {
						perPage: 4,
						perMove: 4,
						gap: '2.4rem'
					}
				}
			},
			sliders = []

		document.querySelectorAll( '.splide' )?.forEach( (elem ) => {
			let slider_id = uuidv4()
			
			elem.setAttribute( 'data-slider-id', slider_id )
			sliders[ slider_id ] = new Splide( elem, slider_options ).mount()
		})

		document.querySelectorAll( '.calender-navigation a[rel]' )?.forEach( ( elem ) => {
			elem.addEventListener( 'click', ( ev ) => {
				ev.preventDefault()

				let clicked_elem = ev.target,
					clicked_rel = clicked_elem.getAttribute( 'rel' )

				document.querySelectorAll('.events-container')?.forEach( (cont) => {
					if ( cont.getAttribute( 'rel' ) != clicked_rel ) {
						cont.classList.add( 'is-hidden' )
					} else {
						cont.classList.remove( 'is-hidden' )
					}
				})
				
				document.querySelectorAll('.calender-navigation a')?.forEach( (cont) => {
					if ( cont.getAttribute( 'rel' ) != clicked_rel ) {
						cont.classList.remove( 'is-active' )
					}
				})

				clicked_elem.classList.add('is-active')
			})
		})
    })
})( )